import { alert } from './alert.mjs';
import { aiConversation } from './aiConversation.mjs';
import { autocomplete } from './autocomplete.mjs';
import { authenticator } from './authenticator.mjs';
import { avatar } from './avatar.mjs';
import { badge } from './badge.mjs';
import { breadcrumbs } from './breadcrumbs.mjs';
import { button } from './button.mjs';
import { card } from './card.mjs';
import { checkbox } from './checkbox.mjs';
import { checkboxfield } from './checkboxField.mjs';
import { collection } from './collection.mjs';
import { copy } from './copy.mjs';
import { dialcodeselect } from './dialCodeSelect.mjs';
import { divider } from './divider.mjs';
import { dropzone } from './dropZone.mjs';
import { accordion } from './accordion.mjs';
import { field } from './field.mjs';
import { fieldcontrol } from './fieldControl.mjs';
import { fieldgroup } from './fieldGroup.mjs';
import { fieldset } from './fieldset.mjs';
import { fieldmessages } from './fieldMessages.mjs';
import { fileuploader } from './fileuploader.mjs';
import { flex } from './flex.mjs';
import { heading } from './heading.mjs';
import { highlightmatch } from './highlightMatch.mjs';
import { icon } from './icon.mjs';
import { input } from './input.mjs';
import { image } from './image.mjs';
import { inappmessaging } from './inAppMessaging.mjs';
import { link } from './link.mjs';
import { liveness } from './liveness.mjs';
import { loader } from './loader.mjs';
import { menu } from './menu.mjs';
import { message } from './message.mjs';
import { pagination } from './pagination.mjs';
import { passwordfield } from './passwordField.mjs';
import { phonenumberfield } from './phoneNumberField.mjs';
import { placeholder } from './placeholder.mjs';
import { radio } from './radio.mjs';
import { radiogroup } from './radioGroup.mjs';
import { rating } from './rating.mjs';
import { searchfield } from './searchField.mjs';
import { select } from './select.mjs';
import { selectfield } from './selectField.mjs';
import { sliderfield } from './sliderField.mjs';
import { stepperfield } from './stepperField.mjs';
import { storagemanager } from './storagemanager.mjs';
import { switchfield } from './switchField.mjs';
import { table } from './table.mjs';
import { tabs } from './tabs.mjs';
import { text } from './text.mjs';
import { textareafield } from './textAreaField.mjs';
import { textfield } from './textField.mjs';
import { togglebutton } from './toggleButton.mjs';
import { togglebuttongroup } from './toggleButtonGroup.mjs';

const components = {
    accordion,
    aiConversation,
    alert,
    authenticator,
    autocomplete,
    avatar,
    badge,
    breadcrumbs,
    button,
    card,
    checkbox,
    checkboxfield,
    collection,
    copy,
    countrycodeselect: dialcodeselect,
    divider,
    dropzone,
    field,
    fieldcontrol,
    fieldgroup,
    fieldmessages,
    fieldset,
    fileuploader,
    flex,
    heading,
    icon,
    highlightmatch,
    image,
    inappmessaging,
    input,
    link,
    liveness,
    loader,
    menu,
    message,
    pagination,
    passwordfield,
    phonenumberfield,
    placeholder,
    radio,
    radiogroup,
    rating,
    searchfield,
    select,
    selectfield,
    sliderfield,
    stepperfield,
    storagemanager,
    switchfield,
    table,
    tabs,
    text,
    textareafield,
    textfield,
    togglebutton,
    togglebuttongroup,
};

export { components };
